import { render } from "./ItemCarouselGroup.vue?vue&type=template&id=6374fac8&scoped=true&ts=true"
import script from "./ItemCarouselGroup.vue?vue&type=script&lang=ts"
export * from "./ItemCarouselGroup.vue?vue&type=script&lang=ts"

import "./ItemCarouselGroup.vue?vue&type=style&index=0&id=6374fac8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6374fac8"]])

export default __exports__